import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isNullOrUndefined } from 'util';
import { environment } from '../environments/environment';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';
var AuthService = /** @class */ (function () {
    function AuthService(jwtHelper, http, router) {
        this.jwtHelper = jwtHelper;
        this.http = http;
        this.router = router;
        this.currentUser = new BehaviorSubject(this.getUserData());
    }
    AuthService.prototype.loggedIn = function () {
        var token = this.getAuthorizationToken();
        return !isNullOrUndefined(this.jwtHelper.tokenGetter()) && !this.jwtHelper.isTokenExpired(token);
    };
    AuthService.prototype.getHeaders = function () {
        return new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json');
    };
    AuthService.prototype.getAuthorizationHeaders = function () {
        return this.getHeaders().set('Authorization', 'JWT ' + this.getAuthorizationToken());
    };
    AuthService.prototype.getAuthorizationToken = function () {
        return this.jwtHelper.tokenGetter();
    };
    AuthService.prototype.setAuthorizationToken = function (token) {
        localStorage.setItem('token', token);
    };
    AuthService.prototype.deleteAuthorizationToken = function () {
        localStorage.removeItem('token');
    };
    AuthService.prototype.setUserData = function (user) {
        localStorage.setItem('user', JSON.stringify(user));
    };
    AuthService.prototype.deleteUserData = function () {
        localStorage.removeItem('user');
    };
    AuthService.prototype.getUserData = function () {
        return JSON.parse(localStorage.getItem('user'));
    };
    AuthService.prototype.signIn = function (user) {
        var _this = this;
        return this.http.post(environment.loginUrl, user, { headers: this.getHeaders() })
            .map(function (response) {
            var _user = response['user'];
            _user.token = response['token'];
            if (!isNullOrUndefined(_user) && !_this.jwtHelper.isTokenExpired(_user.token)) {
                _this.setAuthorizationToken(_user.token);
                _this.setUserData(_user);
                _this.currentUser.next(_user);
            }
            return _user;
        })
            .catch(this.handleError);
    };
    AuthService.prototype.signOut = function () {
        this.deleteAuthorizationToken();
        this.deleteUserData();
        this.router.navigate(['/login']);
    };
    AuthService.prototype.handleError = function (error) {
        var errorMsg;
        if (error instanceof Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errorMsg = error.status + " -  " + (error.statusText || '') + " " + err;
        }
        else {
            errorMsg = error.message ? error.message : error.toString();
        }
        console.log(errorMsg);
        return Observable.throw(errorMsg);
    };
    return AuthService;
}());
export { AuthService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/auth.service.ts.pre-build-optimizer.js